import React from "react";
import "./NoWishList.scss";
import NoCart from "../../assets/no-order.png";

const NoWishList = () => {
  return (
    <div className="no-wishlist-transa">
      <div className="no-wishlist-transa-img">
        <img src={NoCart} alt="No Cart" />
      </div>
      <h4>No product in your Wishlist.</h4>
      <p>You have not saved any products in your wishlist.</p>
    </div>
  );
};

export default NoWishList;
